module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M26.734 5.266v14.34c-.188.49-.524 1.236-.968 1.822-.794 1.052-2.036 2.184-3.134 3.186-.57.52-1.106 1.01-1.56 1.462s-.952.61-1.158.66H5.264V5.266h21.47zm1.814-3.486H3.454c-.924 0-1.672.922-1.672 1.672v25.096c0 .748.75 1.67 1.672 1.67h16.73s1.792-.13 3.346-1.67c1.388-1.38 3.596-3.138 5.018-5.02 1.146-1.516 1.672-3.346 1.672-3.346V3.452c0-.75-.75-1.672-1.672-1.672z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/rawingredients-secondary.js
// module id = 1363
// module chunks = 14